import React, { Fragment } from "react";
import ReactApexChart from "react-apexcharts";
import { KWHText, WattText } from "../Shared/Methods";

export default function Linechart({
  series,
  type,
  labels,
  SeriesKey,
  colour,
  YAxisText,
  XAxisText,
}: {
  series: any;
  type?: string;
  labels: string[];
  SeriesKey: string;
  colour: string;
  YAxisText?: string;
  XAxisText?: string;
}) {
  return (
    <Fragment>
      {/* {series?.length > 0 ? ( */}
      <ReactApexChart
        options={{
          noData: {
            text: "No Data Found",
          },
          chart: {
            // height: 400,
            type: "line",
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          // title: {
          //   text: `${type}`,
          //   align: "left",
          // },
          yaxis: {
            title: {
              text: YAxisText ? YAxisText : undefined,
              style: {
                fontSize: "15px",
              },
            },
          },
          grid: {
            row: {
              colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          labels: labels,
          xaxis: {
            offsetX: 10,
            title: {
              text: XAxisText ? XAxisText : undefined,
              style: {
                fontSize: "15px",
              },
            },
          },
          tooltip: {
            shared: false,
            y: {
              formatter: (value, { w, seriesIndex }) => {
                return SeriesKey === "units"
                  ? `${value} ${WattText}`
                  : `${value} ${KWHText}`;
              },
            },
          },
          // colors: ["#20A2A0", "#f8ca00"],
        }}
        height={300}
        type="line"
        series={[
          {
            data: series.map((ele: any) => ele?.[SeriesKey]),
            name: "Day Wise",
            color: colour,
          },
          // {
          //   name: "Units",
          //   data: series?.map((ele: any) => ele?.units),
          // },
        ]}
      />
      {/* ) : null} */}
    </Fragment>
  );
}
